import { bridge } from './bridge'

import { isPortraitFn } from './'

export const CrossPlatformEventTypes = {
  touchstart: {
    pc: 'mousedown',
    mobile: 'touchstart'
  },
  touchmove: {
    pc: 'mousemove',
    mobile: 'touchmove'
  },
  touchend: {
    pc: 'mouseup',
    mobile: 'touchend'
  }
}
export const CrossPlatformEvent = (type: keyof typeof CrossPlatformEventTypes) => {
  return bridge.isPc ? CrossPlatformEventTypes[type].pc : CrossPlatformEventTypes[type].mobile
}

export const uniqueItems = (items: any[]) => {
  return items.filter((item, index, self) => index === self.findIndex((t) => t.id === item.id))
}

export const toPx = (num: number): number => {
  const resultWidth = isPortraitFn()
    ? document.documentElement.clientWidth
    : Math.min(screen.width, screen.height)
  const width = bridge.isPc ? 450 : resultWidth
  return Math.floor(num * (width / 750))
}

export const showH5Tabbar = true
